<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { DependentEntityInfo } from "@common/types"
    import type { WeightsSetDependenciesViewerViewModel } from "@Criteria/Weights/Components/WeightsSetDependenciesViewer"
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes"
    import { useRoute } from 'vue-router'

    // ---------------- props ----------------

    const props = defineProps({
        viewModel: {
            type: Object as PropType<WeightsSetDependenciesViewerViewModel>,
            required: true
        }
    })

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')
    const route = useRoute()

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const initialized = computed(() => vm.value.initialized)

    const weightsSetName = computed(() => vm.value.weightsSetName)
    const dependenciesCount = computed(() => vm.value.dependenciesCount)
    const weightedScores = computed<DependentEntityInfo[]>(() => vm.value.weightedScores)

    // ---------------- helpers ----------------

    function url_EditWeightedScorePage(e: DependentEntityInfo)
    {
        return dynamicUiRoutes.Criteria_EditWeightedScorePage2(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            Number.parseInt(e.Id)
        )
    }

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Weights set dependencies</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <h3 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Checking dependencies... </h3>
                        <div v-if="initialized">
                            <div class="alert alert-warning text-dark" role="alert">
                                <p>
                                    The weights set '<strong>{{weightsSetName}}</strong>' is used in <strong>{{dependenciesCount}}</strong> places.
                                </p>
                            </div>
                            <div>
                                <div class="card" v-if="weightedScores.length > 0">
                                    <div class="card-header">
                                        Weighted scores (<span>{{weightedScores.length}}</span>)
                                    </div>
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item" v-for="ws in weightedScores" :key="ws.Id">
                                            <a class="text-primary" v-sanitizedHref="url_EditWeightedScorePage(ws)">{{ws.Name}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
